import { createContext, useContext, useEffect, useState } from "react";

const DataSaverContext = createContext(null);
export const useDataSaver = () => useContext(DataSaverContext);

export function DataSaverProvider({ children }) {
  const [dataSaver, setDataSaver] = useState(() => {
    const stored = localStorage.getItem("mus_data_saver");
    if (stored !== null) return stored === "1";
    // Auto-detect slow networks
    const c = navigator.connection;
    if (c && (c.saveData || ["slow-2g", "2g", "3g"].includes(c.effectiveType))) return true;
    return false;
  });

  useEffect(() => {
    localStorage.setItem("mus_data_saver", dataSaver ? "1" : "0");
    document.documentElement.classList.toggle("data-saver", dataSaver);
  }, [dataSaver]);

  return (
    <DataSaverContext.Provider value={{ dataSaver, toggle: () => setDataSaver((v) => !v), setDataSaver }}>
      {children}
    </DataSaverContext.Provider>
  );
}
